import type { AffiliateReferenceResponse } from '@modules/affiliate-reference/types';
import type { IContextQueryResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_REFERENCE_API_URL,
  AFFILIATE_REFERENCE_PERMISSIONS,
  AFFILIATE_REFERENCE_QUERY_KEY,
} from '@modules/affiliate-reference/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

export default function useAffiliateReferenceQuery():
IContextQueryResult<AffiliateReferenceResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [AFFILIATE_REFERENCE_QUERY_KEY],
    queryFn: () => fetchGet<AffiliateReferenceResponse>(
      AFFILIATE_REFERENCE_API_URL,
      {
        permission: AFFILIATE_REFERENCE_PERMISSIONS.SHOW,
      },
    ),
  });
}
